export const USER_DETAILS_CLIENT_CANCEL = `
Ao cancelar esse cliente, ele perderá o acesso a plataforma e sua proposta será cancelada automaticamente.
Essa ação é irrevogavel, você realmente deseja cancelar ?`

export const USER_DETAILS_USER_CANCEL = `
Ao cancelar esse usuário, ele perderá o acesso a plataforma. Essa ação é irrevogavel, você realmente deseja cancelar ?`
